var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0234375 48.4106L7.40857 1.154C7.49884 0.574444 7.94958 0.117572 8.52786 0.0193307C9.10614 -0.0789106 9.6824 0.203728 9.9589 0.720983L17.5964 14.9661L20.6407 9.16983C20.8765 8.72165 21.3413 8.44103 21.8477 8.44103C22.3542 8.44103 22.8189 8.72165 23.0547 9.16983L43.6656 48.4105L0.0234375 48.4106Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5372 30.002L17.5929 14.959L0.0234375 48.4102L25.5372 30.002Z",
    fill: "#F57C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6658 48.4104L38.0094 13.4078C37.9239 12.9052 37.5652 12.4922 37.0794 12.3366C36.5936 12.1809 36.0619 12.3105 35.7011 12.6709L0.0234375 48.4099L19.7648 59.4808C21.0045 60.173 22.5143 60.173 23.754 59.4808L43.6658 48.4099V48.4104Z",
    fill: "#FFCA28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0098 13.4077C37.9243 12.905 37.5656 12.4921 37.0798 12.3365C36.594 12.1808 36.0623 12.3104 35.7015 12.6707L28.6203 19.7699L23.052 9.16931C22.8162 8.72114 22.3515 8.44051 21.845 8.44051C21.3386 8.44051 20.8738 8.72114 20.638 9.16931L17.5937 14.9656L9.95584 0.720694C9.67888 0.203302 9.10192 -0.0788783 8.52296 0.0200955C7.944 0.119069 7.49477 0.577086 7.4055 1.1571L0.023805 48.4103H0L0.023805 48.4376L0.218136 48.533L35.6912 13.019C36.0518 12.6566 36.5848 12.5264 37.0719 12.6816C37.559 12.8368 37.9184 13.2513 38.003 13.7554L43.6117 48.4443L43.6663 48.4102L38.0098 13.4077ZM0.0885822 48.3455L7.40893 1.49129C7.49811 0.911272 7.94839 0.453255 8.52685 0.354281C9.10531 0.255307 9.68231 0.537396 9.95973 1.05488L17.5968 15.3L20.6411 9.50372C20.8768 9.05555 21.3416 8.77493 21.8481 8.77493C22.3545 8.77493 22.8193 9.05555 23.0551 9.50372L28.5104 19.879L0.0885822 48.3455Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.754 59.1472C22.5143 59.8394 21.0046 59.8394 19.7649 59.1472L0.0711846 48.1071L0.0234375 48.4106L19.7648 59.4781C21.0045 60.1703 22.5143 60.1703 23.754 59.4781L43.6658 48.4106L43.6147 48.0969L23.754 59.1472Z",
    fill: "#A52714"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9527 13.4153C37.8676 12.9128 37.5101 12.4997 37.026 12.345C36.5419 12.1902 36.0121 12.3189 35.6525 12.6792L28.5957 19.7748L23.0473 9.17905C22.8123 8.73106 22.3492 8.45053 21.8445 8.45053C21.3399 8.45053 20.8768 8.73106 20.6418 9.17905L17.6077 14.9728L9.99699 0.73382C9.72094 0.216657 9.14605 -0.0654776 8.5696 0.033542C7.99316 0.132562 7.54443 0.590212 7.45558 1.17009L0.0996094 48.4026L19.772 59.4652C21.0073 60.157 22.5119 60.157 23.7472 59.4652L43.5895 48.4026L37.9527 13.4152V13.4153Z",
    fill: "url(#paint0_linear_166_579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_579",
    x1: -151.68,
    y1: 1020.71,
    x2: 5275.47,
    y2: 3883.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.568c10cbdd8846f965d21679d3f9e798.svg";
export { ForwardRef as ReactComponent };